import { lazy } from 'react';

// 角色列表
const RoleList = lazy(() => import('pages/roleList'));
// 角色编辑
const RoleEdit = lazy(() => import('pages/roleEdit'));
// 账号列表
const AccountList = lazy(() => import('pages/accountList'));
// 账号编辑
const AccountEdit = lazy(() => import('pages/accountEdit'));

export const router = {
    path: '/authority',
    name: '权限管理',
    icon: 'wallet',
    permission: 106,
    children: [
        {
            path: 'roleList',
            name: '角色管理',
            icon: 'profile',
            permission: 10601,
            component: RoleList,
        },
        {
            path: 'roleEdit',
            icon: '_space',
            hideInMenu: true,
            name: '角色编辑',
            permission: 10601,
            component: RoleEdit,
        },
        {
            path: 'accountList',
            name: '账号管理',
            permission: 10602,
            icon: 'profile',
            component: AccountList,
        },
        {
            path: 'accountEdit',
            icon: '_space',
            hideInMenu: true,
            name: '账号编辑',
            permission: 10602,
            component: AccountEdit,
        },
    ],
};

export default router;
